import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';

import { HomeComponent } from './components/home/home.component';

import { AuthenticatedRoutes } from './authenticated-routes';
import { TokenGuard } from './guards/authGuard';
import { loginGuard } from './guards/loginGuard';

const routes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'home',
    },
    {
        path: 'auth',
        canActivate: [loginGuard],
        loadChildren: () =>
            import('./components/auth/auth-routing.module').then(
                (m) => m.AuthRoutingModule,
            ),
    },
    {
        path: 'home',
        component: HomeComponent,
        children: AuthenticatedRoutes,
    },
    {
        path: 'pay',
        loadComponent: () =>
            import('./components/upon-pay/upon-pay.component').then(
                ({ UponPayComponent }) => UponPayComponent,
            ),
        canActivate: [TokenGuard],
        children: [
            {
                path: 'success',
                loadComponent: () =>
                    import('./components/upon-pay/pay-success/pay-success.component').then(
                        ({ PaySuccessComponent }) => PaySuccessComponent,
                    ),
            },
            {
                path: 'fail',
                loadComponent: () =>
                    import('./components/upon-pay/pay-fail/pay-fail.component').then(
                        ({ PayFailComponent }) => PayFailComponent,
                    ),
            },
        ],
    },
    {
        path: '503',
        loadComponent: () =>
            import('./service-unavailable/service-unavailable.component').then(
                ({ ServiceUnavailableComponent }) =>
                    ServiceUnavailableComponent,
            ),
    },
    {
        path: '404',
        loadComponent: () =>
            import('./components/not-found/not-found.component').then(
                ({ NotFoundComponent }) => NotFoundComponent,
            ),
    },
    {
        path: '**',
        loadComponent: () =>
            import('./components/not-found/not-found.component').then(
                ({ NotFoundComponent }) => NotFoundComponent,
            ),
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
